// PROD-3310 billing bridge.
// Mirrors: dev-scrips-pm-react src/components/ui/tooltip.tsx (base-ui Tooltip; `TooltipTrigger` defaults
// `delay={0} closeDelay={0}` — "tooltips show at once and leave at once", Antonin 13 Oct).
// Wraps:   Signal DS `Tooltip`, `TooltipTrigger`, `TooltipContent`, `TooltipProvider` (the same base-ui parts, so
// `render`, `side`, `align`, `sideOffset` pass straight through).
// Overrides: the trigger's open and close delay default to 0, as in PM. Root, content and provider are re-exported.
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { TooltipTrigger } from '@scripsteam/scrips-signal-ds';

export { Tooltip, TooltipContent, TooltipProvider } from '@scripsteam/scrips-signal-ds';

type DsTriggerProps = ComponentPropsWithoutRef<typeof TooltipTrigger>;

export const BridgeTooltipTrigger = forwardRef<HTMLButtonElement, DsTriggerProps>(function BridgeTooltipTrigger(
  { delay = 0, closeDelay = 0, ...props },
  ref,
) {
  return <TooltipTrigger ref={ref} delay={delay} closeDelay={closeDelay} {...props} />;
});
